var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dynamic-form-read-only"
  }, [_c('section', {
    staticClass: "dynamic-form-read-only__subjects"
  }, _vm._l(_vm.inputSubjects, function (subject, index) {
    return _c('b-card', {
      key: index,
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "subject"
    }, [_c('div', {
      staticClass: "subject__index d-flex align-items-center"
    }, [_c('span', {
      staticClass: "subject__sequence"
    }, [_vm._v("第 " + _vm._s(index + 1) + " 題")]), _c('i', {
      staticClass: "mdi mdi-18px ml-3",
      class: _vm.subjectTypeIcon(subject.type)
    })]), _c('div', {
      staticClass: "subject__title"
    }, [_c('b-form-input', {
      attrs: {
        "value": _vm.subjectValue('title', subject),
        "disabled": true
      }
    })], 1), _c('div', {
      staticClass: "subject__id",
      attrs: {
        "tabindex": "0"
      }
    }, [_c('b-form-input', {
      attrs: {
        "value": _vm.subjectValue('_id', subject),
        "readonly": ""
      }
    }), _c('i', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.click.blur",
        value: '已複製',
        expression: "'已複製'",
        modifiers: {
          "click": true,
          "blur": true
        }
      }],
      staticClass: "subject__copy-icon mdi mdi-18px mdi-content-copy",
      on: {
        "click": function click($event) {
          _vm.copyAssignUrl(_vm.subjectValue('_id', subject));
        }
      }
    })], 1)])]);
  }), 1), _c('div', {
    staticClass: "mt-3 d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" 返回 ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }